import FingerprintJS from '@fingerprintjs/fingerprintjs'

// ----------------------------------------------------------------------

const FPID_STORAGE_KEY = 'fpid'

let fpPromise: Promise<string> | null = null

/**
 * Initialize and get fingerprint ID
 * Uses cached value from localStorage if available, otherwise generates new one
 */
async function getFingerprintId(): Promise<string> {
	// Check if we already have a cached fingerprint
	const cachedFpid = localStorage.getItem(FPID_STORAGE_KEY)
	if (cachedFpid) {
		return cachedFpid
	}

	// If already initializing, return the promise
	if (fpPromise) {
		return fpPromise
	}

	// Initialize fingerprint.js
	fpPromise = (async () => {
		try {
			const fp = await FingerprintJS.load()
			const result = await fp.get()
			const visitorId = result.visitorId

			// Cache the fingerprint ID in localStorage
			localStorage.setItem(FPID_STORAGE_KEY, visitorId)

			return visitorId
		} catch (error) {
			console.error('Error generating fingerprint:', error)
			// Fallback: generate a simple ID based on available data
			const fallbackId = `fp_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`
			localStorage.setItem(FPID_STORAGE_KEY, fallbackId)
			return fallbackId
		}
	})()

	return fpPromise
}

/**
 * Get fingerprint ID synchronously (returns cached value or null)
 */
export function getFingerprintIdSync(): string | null {
	return localStorage.getItem(FPID_STORAGE_KEY)
}

/**
 * Get fingerprint ID asynchronously (generates if not cached)
 */
export async function getFingerprintIdAsync(): Promise<string> {
	return getFingerprintId()
}

/**
 * Clear cached fingerprint ID (useful for testing or reset)
 */
export function clearFingerprintId(): void {
	localStorage.removeItem(FPID_STORAGE_KEY)
	fpPromise = null
}
